import { render, staticRenderFns } from "./InputDlg.vue?vue&type=template&id=66f31d8c&scoped=true"
import script from "./InputDlg.vue?vue&type=script&lang=js"
export * from "./InputDlg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f31d8c",
  null
  
)

export default component.exports